import getKey from './get-key';

const photoArray = (array) => {
  const collect = (array) => {
    let result = [];
    array.forEach((el) => {
      if (getKey(el) == 'two_column') {
        result.push(el.two_column[0].image);
        result.push(el.two_column[1].image);
      } else {
        result.push(el.image);
      }
    });
    return result;
  };

  return {
    carousel_array: collect(array),
    flex_array: array
  };
};

export default photoArray;



// WEBPACK FOOTER //
// ./src/scripts/photo-array.js